import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import BallastDetail from '../../components/light/BallastDetail';
import { editBallast, getBallast } from '../../redux/luminaire/ballast_actions';
import { defaultRejectHandler } from '../../utils/utility';

class BallastEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.ballastDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.ballast !== nextProps.ballast) && nextProps.show) {
      this.props.getBallast(nextProps.ballast.id);
    }
  }

  onSaveHandler() {
    const newBallast = this.ballastDetail.getWrappedInstance().getWrappedInstance().getBallastData();
    this.props.editBallast({ ...newBallast, id: this.props.ballast.id });
  }

  render() {
    const { isEditing, errorMessage, ballast, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit ballast')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BallastDetail
            ballast={ballast}
            ref={ref => this.ballastDetail = ref}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-ballast-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const ballastState = state.lighting.ballast;
  return {
    errorMessage: ballastState.errorMessage,
    isEditing: ballastState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editBallast: ballast =>
    defaultRejectHandler(
      dispatch(
        editBallast(
          ballast.id,
          ballast.name,
          ballast.brand_id,
          ballast.type_id,
          ballast.power_required,
          ballast.description || '',
          ballast.image,
          ballast.cfp_value,
          ballast.cfp_unit,
        ),
      ),
    ),
  getBallast: id =>
    defaultRejectHandler(
      dispatch(getBallast(id)
      )
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BallastEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/ballast/BallastEditModal.js